/// <amd-module name="Build/Stats/PipelinesMetricsSection" />

import * as  React from "react";
import { css } from "VSSUI/Util";

import { IVssContributionService } from "VSS/Platform/Contribution";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import {
    Components,
    IVssComponentContext,
    IVssComponentProperties,
    IVssLayoutManager,
    RegionComponent,
    VssComponent
} from "VSS/Platform/Layout";

import * as Resources from "Build/Stats/Resources";

const PipelineMetricsRegion= "PipelineMetricsRegion";

interface PipelinesMetricsSectionProps extends IVssComponentProperties {
    numOfDays: number;
}

class PipelinesMetricsSection extends VssComponent<PipelinesMetricsSectionProps, {}> {

    private readonly _serviceName: string | undefined;

    constructor(props: PipelinesMetricsSectionProps, context: IVssComponentContext) {
        super(props, context);

        const serviceInfo = context.pageContext.getService<IVssContributionService>("IVssContributionService")
            .getContribution<{ name: string; }>("ms.vss-build-web.pipelines-service-navigation-info");

        if (serviceInfo) {
            this._serviceName = serviceInfo.name;
        }
    }

    public render(): JSX.Element | null {
        const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        const childComponents = layoutManager.getComponentsForRegion(PipelineMetricsRegion);

        return childComponents.length > 0
            ?
            <div className={css(this.props.className, "pipelines-metric-tile")}>
                {this._serviceName && <div className="body-l">{this._serviceName}</div>}
                <RegionComponent
                    className={"flex"}
                    componentRegion={PipelineMetricsRegion}
                    childComponentProperties={{ numOfDays: this.props.numOfDays }}
                />
            </div>
            :
            null;

    }
}

Components.add("Pipelines.PipelinesStats", PipelinesMetricsSection);
